import { useEffect, useRef } from "react";
import Category from "./Category";
import { useCategoryDataContext } from "./context/CategoryDataContext";
import { useScore } from './context/ScoreContext';
import CloseButton from "./CloseButton";
import { getRarityFromPercentage, getRarityEmoji } from "./util";

const OptionCard = ({ day, name, id, rarity, optionId, onClose, onUpdateCS }) => {
    const categoryData = useCategoryDataContext();
    const cardRef = useRef(null);
    const category1 = 3 + Math.ceil(optionId / 3);
    const category2 = (optionId % 3) + (optionId % 3 === 0 ? 3 : 0);
    const { gameEnded, cs } = useScore();
    // console.log(id, rarity);
    useEffect(() => {
        // Ensure the div is focusable
        cardRef.current.setAttribute('tabIndex', '0');
        // Focus on the div when the component mounts
        cardRef.current.focus();
    }, []);

    const imageUrl = id > 0 ? `https://static.atlasacademy.io/JP/Servants/Status/${id}/status_servant_1.png` : 'test.png';
    // console.log(rarity);
    const useCommandSpell = () => {
        if (cs > 0 && !gameEnded) {
            // updateCommandSpell(getCScount() - 1);
            onUpdateCS();
            onClose();
        }
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Escape') {
            onClose();
        }
    };


    return (
        <div className="info-card" ref={cardRef} onKeyDown={handleKeyPress}>
            <CloseButton onClose={onClose} />
            <div className="info-card-gradient">
                <div className={id > 0 ? "light-particles" : ""}>
                    <div className="info-card-items">
                        <Category classType={"info-card-item"} data={categoryData[category1]} />
                        <img className="info-card-servent" src={imageUrl}
                            style={id <= 0 ? { width: "20%", paddingTop: "20px", paddingBottom: "15px", mixBlendMode: "hard-light" } : {}} />
                        <Category classType={"info-card-item"} data={categoryData[category2]} />
                    </div>
                </div>
            </div>
            <div className="info-card-details">
                <h1>{name}</h1>
                {/* <h3>{getRarityEmoji(id, rarity)}{getRarityFromPercentage(id, rarity)?.toUpperCase()}{getRarityEmoji(id, rarity)}</h3>
                {rarity >= 0 && <h4>{(rarity * 100).toPrecision(3)}% selected</h4>} */}
                <p style={{ paddingTop: "10px" }}>{id <= 0 && "You can try again! Use your command spell to undo and select again."}</p>

                {id < 0 && <button className={`use-command-spell ${gameEnded ? "cursor-not-allowed" : "cursor-pointer"}`}
                    onClick={useCommandSpell}>{cs > 0 ? "Use Command Spell" : "No Command Spells left"}</button>}
            </div>
        </div>
    );
}

export default OptionCard;